/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
// import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";
// import { NavCardsSimpleSection } from "cms/components/components/nav-cards-simple/display/section-list";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";

const NavCardsSimpleEditor = () => {
    
    // const webpage = useGetCurrentWebpage();
    const { component, updateFactory } = useUpdateComponent();
    
    const onChangeDescription = updateFactory("description");

    return (
        <div className="simplicity-editor-frame">
            <Typography variant='overline' color={"text.secondary"}>
                Description:{" "}
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={component.description}
                onChange={onChangeDescription}
            />
            <div style={{ padding: "0 2em" }}>
                <Typography variant='body2' color='text.secondary'>
                    (Nav Cards Simple Component is generated on the client by getting nav card items
                    based on this page. You can see this in Preview.)
                </Typography>
            </div>
        </div>
    );
};

NavCardsSimpleEditor.displayName = "NavCardsSimpleEditor";
export { NavCardsSimpleEditor };
